// files from theme
import "./main";
import swiper from './components/swiper';

try {
  // safety loader
  if (!window.$) {
    window.$ = window.jQuery = require('jquery');

  }

  document.addEventListener('DOMContentLoaded', () => {
  });

  jQuery(document).ready(function($) {
    swiper();
  });
}
catch (e) {}